<template>
  <div class="home">
    <prayer-countdown></prayer-countdown>
    <prayer-times></prayer-times>
    <zakat-calculator></zakat-calculator>
    <about></about>
  </div>
</template>

<script>
import PrayerCountdown from '@@/PrayerCountdown.vue';
import PrayerTimes from '@@/PrayerTimes.vue';
import ZakatCalculator from '@@/ZakatCalculator';
import About from '@@/About';

export default {
  name: 'home',
  components: {
    PrayerCountdown,
    PrayerTimes,
    ZakatCalculator,
    About
  },

  computed: {
  },

  created() {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue